/**
 * 权限码（随业务扩展）
 */
const PERMISSIONS = {
    USER_MANAGE: 'user-manage',
    USER_MANAGE_LIST: 'user-manage:list',
    USER_MANAGE_EDIT: 'user-manage:edit',
    USER_MANAGE_RESET_PASSWORD: 'user-manage:resetPassword',

    // 模型管理
    AI_MODEL: 'ai-model',
    AI_MODEL_LIST: 'ai-model:list',
    AI_MODEL_CREATE: 'ai-model:create',
    AI_MODEL_EDIT: 'ai-model:edit',
    AI_MODEL_DELETE: 'ai-model:delete',

    // 模板管理（版式模板 + 首页案例）
    DESIGN_TEMPLATE: 'design-template',
    DESIGN_TEMPLATE_LIST: 'design-template:list',
    DESIGN_TEMPLATE_CREATE: 'design-template:create',
    DESIGN_TEMPLATE_EDIT: 'design-template:edit',
    DESIGN_TEMPLATE_DELETE: 'design-template:delete',
    DESIGN_CASE_LIST: 'design-case:list',
    DESIGN_CASE_CREATE: 'design-case:create',
    DESIGN_CASE_EDIT: 'design-case:edit',
    DESIGN_CASE_DELETE: 'design-case:delete',
    DESIGN_SKILL_LIST: 'design-skill:list',
    DESIGN_SKILL_CREATE: 'design-skill:create',
    DESIGN_SKILL_EDIT: 'design-skill:edit',
    DESIGN_SKILL_DELETE: 'design-skill:delete',
    DESIGN_PIPELINE_LIST: 'design-pipeline:list',
    DESIGN_PIPELINE_CREATE: 'design-pipeline:create',
    DESIGN_PIPELINE_EDIT: 'design-pipeline:edit',
    DESIGN_PIPELINE_DELETE: 'design-pipeline:delete',
    DESIGN_GENERATE_RUN_LIST: 'design-generate-run:list',

    // AI 创作
    AI_CREATE: 'ai-create',
    CREATE_CONVERSATION_LIST: 'create-conversation:list',
    DESIGN_SQUARE_LIST: 'design-square:list',
    DESIGN_SQUARE_EDIT: 'design-square:edit',

    // 设计稿管理
    DESIGN_DOC: 'design-doc',
    DESIGN_DOC_LIST: 'design-doc:list',
    DESIGN_DOC_PENDING: 'design-doc:pending',

    // 素材管理（官方素材库）
    ASSET: 'asset',
    ASSET_LIST: 'asset:list',
    ASSET_CREATE: 'asset:create',
    ASSET_EDIT: 'asset:edit',
    ASSET_DELETE: 'asset:delete',
    ASSET_CATEGORY: 'asset:category',
    ASSET_CATEGORY_CREATE: 'asset:category.create',
    ASSET_CATEGORY_EDIT: 'asset:category.edit',
    ASSET_CATEGORY_DELETE: 'asset:category.delete',
    ASSET_FAVORITE: 'asset:favorite',
    ASSET_FAVORITE_DELETE: 'asset:favorite.delete',

    // 默认头像管理
    AVATAR: 'avatar',
    AVATAR_LIST: 'avatar:list',
    AVATAR_CREATE: 'avatar:create',
    AVATAR_EDIT: 'avatar:edit',
    AVATAR_DELETE: 'avatar:delete',

    // 套餐管理
    PLAN: 'plan',
    PLAN_LIST: 'plan:list',
    PLAN_CREATE: 'plan:create',
    PLAN_EDIT: 'plan:edit',
    PLAN_DELETE: 'plan:delete',
    PLAN_FEATURE_LIST: 'plan:feature.list',
    PLAN_ORDER_LIST: 'plan:order.list',

    // 系统管理
    SYSTEM: 'system',

    // 管理员管理
    ADMIN: 'system:admin',
    ADMIN_CREATE: 'system:admin.create',
    ADMIN_EDIT: 'system:admin.edit',
    ADMIN_UPDATESTATUS: 'system:admin.updateStatus',
    ADMIN_ASSIGNROLE: 'system:admin.assignRole',
    ADMIN_DELETE: 'system:admin.delete',

    // 角色管理
    ADMIN_ROLE_LIST: 'system:role',
    ADMIN_ROLE_CREATE: 'system:role.create',
    ADMIN_ROLE_EDIT: 'system:role.edit',
    ADMIN_ROLE_ASSIGN_PERMISSION: 'system:role.assign_permission',
    ADMIN_ROLE_DELETE: 'system:role.delete',

    // 权限管理
    ADMIN_PERMISSION: 'system:permission',
    ADMIN_PERMISSION_CREATE: 'system:permission.create',
    ADMIN_PERMISSION_EDIT: 'system:permission.edit',
    ADMIN_PERMISSION_DELETE: 'system:permission.delete',

    // 系统配置
    SYSTEM_CONFIG: 'system:config',
    SYSTEM_CONFIG_LIST: 'system:config.list',
    SYSTEM_CONFIG_CREATE: 'system:config.create',
    SYSTEM_CONFIG_EDIT: 'system:config.edit',
    SYSTEM_CONFIG_DELETE: 'system:config.delete',
} as const;

export default PERMISSIONS;
